import styles from './SetCredPage.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { setCredentialActions } from '../../../../stores/_actions';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';
import hidden from 'assets/images/icn-show.svg';
import show from 'assets/images/icn-hidden.svg';
import { PopupModel } from '../../../components/popup/PopupModel';

function SetCredentialsPage() {
  const history = useHistory();
  const jsonData = localStorage.getItem('customer');
  const customer = JSON.parse(jsonData);

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      Password: '',
      MobileNo: customer?.MobileNo,
      MPIN: '',
      DeviceType: customer?.DeviceType,
      IDNO: customer?.IDNO,
      DeviceID: customer?.DeviceID,
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };
  const [setCred, setCrede] = useState({
    MPIN: '',
    Password: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [modelPopup, openPopup] = useState(false);
  const credentials = useSelector((state) => state.setCredential?.data);
  const url = ['/', '/set-credentials'];

  const hidePopup = () => {
    openPopup(false);
    credentials.statusCode == '200' || credentials.statusCode == '201'
      ? history.push({ pathname: '/', state: {} })
      : history.push({ pathname: '/set-credentials', state: {} });
  };

  // const loggingIn = useSelector((state) => state.authentication.loggingIn);
  const dispatch = useDispatch();
  const location = useLocation();

  const [type, TextType] = useState('password');
  const InputType = () => (type == 'password' ? TextType('text') : TextType('password'));

  const handleChange = (e) => {
    let errorMsg;
    setPwdErr('');
    setCrede((setCred) => ({ ...setCred, errorMsg: '' }));
    const { name, value } = e.target;
    if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {
      const checkValidpass = Validator.digitsOnly(value);
      if (!checkValidpass) {
        errorMsg = 'Only digits allowed';
        setCrede((setCred) => ({ ...setCred, [name]: '' }));
        setCrede((setCred) => ({ ...setCred, errorMsg: errorMsg }));
        return;
      }
    }
    setCrede((setCred) => ({ ...setCred, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!setCred.Password) {
      setPwdErr('Transaction Password is required');
      return;
    } else if (setCred.Password.length < 8) {
      setPwdErr('Please enter 8 digit password');
      return;
    }
    if (setCred.one && setCred.two && setCred.three && setCred.four && setCred.five && setCred.six && setCred.Password) {
      payload.Data['MPIN'] = `${setCred.one}${setCred.two}${setCred.three}${setCred.four}${setCred.five}${setCred.six}`;
      payload.Data['Password'] = setCred.Password;
      dispatch(setCredentialActions.setCredintial(payload));
      openPopup(true);
    }
  };

  // start Autofocus with textbox //
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [pwdErr, setPwdErr] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  useMountEffect(setInput1Focus);
  // end Autofocus with textbox //

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.SetCredentials.heading}</h1>
          <form name="resetpass" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>Set MPIN</label>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="one"
                autoComplete="off"
                value={setCred.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="two"
                autoComplete="off"
                value={setCred.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="three"
                autoComplete="off"
                value={setCred.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="four"
                autoComplete="off"
                value={setCred.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="five"
                autoComplete="off"
                value={setCred.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="six"
                autoComplete="off"
                value={setCred.six}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
              />
              <div className={styles.formgroup__error}>{setCred.errorMsg}</div>
              {submitted && !(setCred.one && setCred.two && setCred.three && setCred.four && setCred.five && setCred.six) && (
                <div className={styles.formgroup__error}>Enter MPIN</div>
              )}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>Set Transaction Password</label>
              {/* <input className={styles.width50} type="text" /> */}
              <input
                type={type}
                name="Password"
                maxLength="8"
                value={setCred.Password}
                onChange={handleChange}
                className={styles.width50}
                style={{ textAlign: 'left' }}
              />
              <img src={type == 'text' ? hidden : show} alt="" onClick={InputType} className={type == 'text' ? styles.hidden : styles.show} />
              {submitted && pwdErr && <div className={styles.formgroup__error}>{pwdErr}</div>}
            </div>
            {/* <a className={styles.LoginPage__link} href="#">
            confirm
          </a> */}
            <input type="submit" value={Label.SetCredentials.buttonLabel} className={styles.LoginPage__link} />
            {credentials != undefined ? (
              <div className={styles.formgroup__error}>
                <h5>{credentials?.statusCode !== '200' && credentials?.statusCode !== '201' ? credentials.message : ''}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
          {modelPopup ? <PopupModel data={credentials} url={url} /> : ''}
          {/* <p className={styles.LoginPage__alrmember}>
            Already Registered? <Link to="/">Login!</Link>
          </p> */}
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { SetCredentialsPage };
